exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-actions-process .dropdown-trigger{display:flex}.dropdown-actions-process .dropdown-trigger .button:focus{border-color:unset!important;box-shadow:unset!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fa8465e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cultura/components/Process/ActionsProcess.vue
// module id = 1482
// module chunks = 2